// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Typography, TypographyProps } from '@mui/material';

// props
export interface TypographyCaptionProps extends Omit<TypographyProps, 'id'> {
	id?: null | number | string | undefined;
}

export const TypographyCaption = ({ children, id, ...props }: TypographyCaptionProps) => {
	// hooks
	const { t } = useTranslation();

	let content = children;

	if (id !== undefined) {
		content = `ID ${id || t('na')}`;
	}

	if (content) {
		return (
			<Typography
				color="brand.grey.500"
				component="div"
				fontWeight={600}
				variant="caption"
				{...props}>
				{content}
			</Typography>
		);
	}

	return null;
};
